import { queryFetch } from '../api';
import { useMutation } from '@tanstack/react-query';
import { useShowErrorToast } from '@utils/formHelpers';
import { WebpushResp } from './types';

export const useRemoveWebPush = ({ callback }: { callback: (data: WebpushResp) => void }) => {
  const { showErrorToast } = useShowErrorToast();

  const { mutate, isPending } = useMutation({
    mutationFn: (): Promise<WebpushResp> =>
      queryFetch({ url: 'webpush_notifications/remove_all', opt: { method: 'DELETE' } }),
    onError: (err) => {
      console.error(err);
    },
    onSettled: (data) => {
      if (!data) return;
      const { success, errors } = data as WebpushResp;
      if (errors) showErrorToast(errors);
      if (success) callback(data as WebpushResp);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
